// @flow
import React, { Component } from 'react'
import _ from 'lodash'
import styled, { type StyledComponent } from 'styled-components'
import PrimaryButton from './controls/PrimaryButton'
import TemplateInput from './AudienceNameTemplatePage/TemplateInput'
import type { AudienceNameTemplate } from './types'
import TemplateSelect from './AudienceNameTemplatePage/TemplateSelect'

const ElementWrapper: StyledComponent<Object, any, any> = styled.div`
  padding-bottom: 20px;
`
const TemplateParamWrapper: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  padding-top: 10px;
`
const TemplateParamLabel: StyledComponent<Object, any, any> = styled.span`
  padding-right: 5px;
  line-height: 30px;
  width: 100px;
`

type Props = {|
  templates: Array<AudienceNameTemplate>,
  isLoading: boolean,
  onInit: Function,
  onChange: Function,
  onApply: Function
|}

const t = {
  add: 'Добавить шаблон',
  apply: 'Применить',
  language_label: 'Язык',
  name_label: 'Название',
  template: 'Шаблон',
  value_label: 'Значение'
}

const DEFAULT_TEMPLATE_VALUE =
  '{prefix}/{provider}/{format}/{platform}/{keywords}/{includedGroups}/{includedVkApps}/{vkActivity}/{segments}/{contacts}/{lookalikeSegments}/{lookalikeContacts}/{providerTargetingSources}/{interests}/{gender}/{age}/{location}'

export default class AudienceNameTemplatePage extends Component<Props> {
  constructor(props: Props) {
    super(props)

    props.onInit()
  }

  render() {
    return (
      <div>
        {_.map(this.props.templates, (template, index: number) => {
          return (
            <ElementWrapper key={index}>
              <div>
                <span>{`${t.template} ${index + 1}`}</span>
              </div>
              <TemplateParamWrapper className={`t-AudienceNameTemplate__name-input_${index}`}>
                <TemplateParamLabel>{t.name_label}</TemplateParamLabel>
                <TemplateInput
                  isLoading={this.props.isLoading}
                  value={template.name}
                  onBlur={(name) => {
                    let newTemplates = this.props.templates
                    newTemplates[index].name = name
                    this.props.onChange({ templates: newTemplates })
                  }}
                />
              </TemplateParamWrapper>
              <TemplateParamWrapper className={`t-AudienceNameTemplate__value-input_${index}`}>
                <TemplateParamLabel>{t.value_label}</TemplateParamLabel>
                <TemplateInput
                  isLoading={this.props.isLoading}
                  value={template.value}
                  onBlur={(value) => {
                    const newTemplates = _.cloneDeep(this.props.templates)
                    newTemplates[index].value = value
                    this.props.onChange({ templates: newTemplates })
                  }}
                />
              </TemplateParamWrapper>
              <TemplateParamWrapper className={`t-AudienceNameTemplate__language-select_${index}`}>
                <TemplateParamLabel>{t.language_label}</TemplateParamLabel>
                <TemplateSelect
                  value={template.language}
                  isLoading={this.props.isLoading}
                  onChange={(language) => {
                    let newTemplates = this.props.templates
                    newTemplates[index].language = language
                    this.props.onChange({ templates: newTemplates })
                  }}
                />
              </TemplateParamWrapper>
            </ElementWrapper>
          )
        })}
        <ElementWrapper>
          <PrimaryButton
            height={32}
            disabled={this.props.isLoading}
            onClick={() =>
              this.props.onChange({
                templates: [
                  ...this.props.templates,
                  { id: null, name: '', value: DEFAULT_TEMPLATE_VALUE, language: 'RU' }
                ]
              })
            }
          >
            {t.add}
          </PrimaryButton>
        </ElementWrapper>
        {this.props.templates.length > 0 && (
          <ElementWrapper>
            <PrimaryButton
              height={32}
              disabled={this.props.isLoading}
              onClick={() => this.props.onApply()}
            >
              {t.apply}
            </PrimaryButton>
          </ElementWrapper>
        )}
      </div>
    )
  }
}
